import Login from '../../features/Login';

export default function LoginPage() {
    return <>
        <Login />
    </>;
}
